import { render } from "./AGRecepcionesIndex.vue?vue&type=template&id=ed93b2d4"
import script from "./AGRecepcionesIndex.vue?vue&type=script&lang=js"
export * from "./AGRecepcionesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/recepciones/AGRecepcionesIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed93b2d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed93b2d4', __exports__)) {
    api.reload('ed93b2d4', __exports__)
  }
  
  module.hot.accept("./AGRecepcionesIndex.vue?vue&type=template&id=ed93b2d4", () => {
    api.rerender('ed93b2d4', render)
  })

}


export default __exports__